import { Button } from '@/components/ui/button';
import { SectionId } from '@/components/OnePager';

interface OnePageNavProps {
  activeSection: SectionId;
  onNavigate: (sectionId: SectionId) => void;
  onNavClick?: () => void;
}

export function OnePageNav({ activeSection, onNavigate, onNavClick }: OnePageNavProps) {
  const handleClick = (sectionId: SectionId) => {
    onNavClick?.();
    onNavigate(sectionId);
  };

  const isActive = (sectionId: SectionId) => activeSection === sectionId;

  return (
    <nav className="sticky bottom-0 w-full border-t border-border bg-background z-50 mt-auto shrink-0">
      <div className="flex items-center justify-evenly w-full max-w-lg mx-auto py-3 px-2">
        <Button 
          variant="ghost" 
          size="lg"
          onClick={() => handleClick('drink-log')}
          className={`text-2xl ${isActive('drink-log') ? 'bg-primary text-primary-foreground' : ''}`}
        >
          ➕
        </Button>
        <Button 
          variant="ghost" 
          size="lg"
          onClick={() => handleClick('rewards')}
          className={`text-2xl ${isActive('rewards') ? 'bg-primary text-primary-foreground' : ''}`}
        >
          🔥
        </Button>
        <Button 
          variant="ghost" 
          size="lg"
          onClick={() => handleClick('leaderboard')}
          className={`text-2xl ${isActive('leaderboard') ? 'bg-primary text-primary-foreground' : ''}`}
        >
          🏆
        </Button>
        <Button 
          variant="ghost" 
          size="lg"
          onClick={() => handleClick('profile')}
          className={`text-2xl ${isActive('profile') ? 'bg-primary text-primary-foreground' : ''}`}
        >
          👤
        </Button>
      </div>
    </nav>
  );
}
